import { useCallback } from "react";

import { useNetwork } from "../../hooks/useNetwork";

import { IIntegrationsEntrata, IIntegrationsMappings } from "../../services/IntegrationApi";

export const useGetRoomSyncFloorPlan = () => {
  const { getL3, getL2, getL4 } = useNetwork();

  const getRoomSyncFloorPlan = useCallback(
    (row: IIntegrationsEntrata | IIntegrationsMappings) => {
      const l2 = getL2(row.l1Id, row.l2Id);
      const l3 = getL3(row.l1Id, row.l2Id, row.l3Id);
      const l4 = getL4(row.l1Id, row.l2Id, row.l3Id, row.l4Id);

      if (l4?.name) {
        return `${l2?.l1Name} - ${l2?.l2Name} - ${l3?.name} - ${l4.name}`;
      }

      if (l3?.name) {
        return `${l2?.l1Name} - ${l2?.l2Name} - ${l3?.name}`;
      }

      if (l2?.l2Name) {
        return `${l2?.l1Name} - ${l2?.l2Name}`;
      }

      return l2?.l1Name;
    },
    [getL2, getL3]
  );

  return getRoomSyncFloorPlan;
};

export const useGetRoomSyncFloorDetails = () => {
  const { getL3, getL2, getL4 } = useNetwork();

  const getRoomSyncFloorPlan = useCallback(
    (row: IIntegrationsEntrata | IIntegrationsMappings) => {
      const l2 = getL2(row.l1Id, row.l2Id);
      const l3 = getL3(row.l1Id, row.l2Id, row.l3Id);
      const l4 = getL4(row.l1Id, row.l2Id, row.l3Id, row.l4Id);

      return ({
        l4Name: l4?.name,
        l4Size: l4?.numberInL3,
        l3Name: l3?.name,
        l3Size: l3?.size,
        l2Name: l2?.l2Name,
      });
    },
    [getL2, getL3]
  );

  return getRoomSyncFloorPlan;
};
